





























import { Vue, Component } from 'vue-property-decorator';

import segmentIo from '@/utils/segment.io';

import {
  loadCoinStoreData,
  setBusinessOnboardingDataOnLocalStorage
} from '@/store/modules/businessOnboarding';

import BaseLayout from './Steps/BaseLayout.vue';
import OnboardingIlustra from './Steps/OnboardingIlustra.vue';

import { saveOauthState } from '@/utils/merchantoauth';
import {
  TRACKING_START_SIGNUP_SESSION_KEY,
  getOauthState,
  isExternalOauthSessionOnline,
  isOauthSession,
  removeExternalOauthSession,
  setExternalOauthSession
} from '@/router/router-utils';
import {
  getBigcommerceAccount,
  getShopifyAccount,
  getWixOauthId,
  insideProviderIframe
} from '@/utils/providerIframe';
import SignUpService from '@/api/SingupService';
import store from '@/store';
import { isOnlineProvider } from '@/utils/provider';
import { IBusinessType } from '@/models/business';

import logger from '@/utils/logger';
import { EBusinessOnboardingInitialFlow } from '@/models/business-onboarding';

@Component({
  components: {
    BaseLayout,
    OnboardingIlustra
  }
})
export default class BusinessOnboarding extends Vue {
  signUpservice = new SignUpService();
  unsub: () => void = () => {};

  get wrapperStyles() {
    const config = this.configByRouteName[this.$route.name as string];

    return {
      '--left-col-width': config.leftColWidth || '32%'
    };
  }

  get routeName(): any {
    return this.$route.name;
  }

  get configByRouteName(): Record<string, any> {
    return {
      'bo-your-digital-coin': {
        wrapperClass: 'customize-coin-width-links',
        hideIlustraOnMobile: true
      },
      'bo-your-account': {
        wrapperClass: 'your-account',
        hideIlustraOnMobile: true,
        leftColWidth: ''
      },
      'bo-your-store': {
        wrapperClass: 'your-store'
      },
      'bo-loading-onboarding': {
        wrapperClass: 'loading-onboarding'
      },
      'bo-loyalty-widget': {
        wrapperClass: '',
        hideIlustraOnMobile: true,
        removeMarginNav: true
      },
      'bo-loyalty-feedback-status': {
        wrapperClass: '',
        hideIlustraOnMobile: true
      },
      'bo-reward-ratio': {
        wrapperClass: '',
        hideIlustraOnMobile: true
      },
      'bo-choose-loyalty-reward': {
        wrapperClass: '',
        hideIlustraOnMobile: true
      }
    };
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get isInsideProviderIframe() {
    return insideProviderIframe();
  }

  get externalOauthSessionOnline() {
    return isExternalOauthSessionOnline();
  }

  get providerName() {
    return this.$route.query.providerName;
  }

  async getRedirectUrlByProvider() {
    switch (this.providerName) {
      case 'shopify':
        return this.signUpservice.connectShopify(getShopifyAccount());
      case 'bigcommerce':
        return this.signUpservice.connectBigcommerce(getBigcommerceAccount());
      case 'wix':
        return this.signUpservice.connectWix(getWixOauthId());
      default:
        return { data: { url: '' } };
    }
  }

  loadCategories = async () => {
    const {
      status,
      data: { categories }
    } = await this.signUpservice.getCategories({ version: 2 });

    if (status !== 200) return;

    const transformedCategories = categories.map((category: any) => ({
      value: category.id,
      label: category.name
    }));

    this.$store.dispatch(
      'businessOnboarding/SET_CATEGORIES',
      transformedCategories
    );
  };

  async mounted() {
    if (this.businessInfo || segmentIo.getIdentifiedId()) {
      segmentIo.reset();
    }
    logger.reset();

    if (!localStorage.getItem(TRACKING_START_SIGNUP_SESSION_KEY)) {
      segmentIo.track('NPO Sign Up | Started Merchant Signup', {
        'Is First Business':
          !this.businessInfo &&
          !Object.keys(getOauthState() || {}).includes(
            'fromSelectBusinessRoute'
          ),
        'Signup from Online Provider': isExternalOauthSessionOnline()
      });
      localStorage.setItem(
        TRACKING_START_SIGNUP_SESSION_KEY,
        EBusinessOnboardingInitialFlow.PROVIDER
      );
    }

    await this.loadCategories();

    const oauthState = getOauthState();

    if (
      this.isInsideProviderIframe &&
      !this.externalOauthSessionOnline &&
      (oauthState && isOnlineProvider(oauthState.provider.name))
    ) {
      setExternalOauthSession(IBusinessType.ONLINE);
      loadCoinStoreData(store);
    }

    if (!isOauthSession() && this.isInsideProviderIframe) {
      const resp = await this.getRedirectUrlByProvider();
      const search = resp.data && resp.data.url && resp.data.url.split('?')[1];
      if (search) {
        const urlParams = new URLSearchParams(search);

        const query = Array.from(urlParams.entries()).reduce(
          (acc, [key, value]) => ({ ...acc, [key]: value }),
          {}
        );
        await saveOauthState(query);
      }
    }

    this.unsub = this.$store.subscribe((mutation, state) => {
      if (
        !mutation.type.startsWith('businessOnboarding/') ||
        this.$route.name === 'bo-your-digital-coin'
      )
        return;

      setBusinessOnboardingDataOnLocalStorage(state.businessOnboarding);
    });

    this.resizeEventHandler();

    window.addEventListener('resize', this.resizeEventHandler);
  }

  beforeDestroy() {
    if (this.businessInfo) {
      logger.identifyBusiness(this.businessInfo.id);
      segmentIo.identifyBusiness(this.businessInfo);
      removeExternalOauthSession();
      localStorage.removeItem(TRACKING_START_SIGNUP_SESSION_KEY);
    }

    this.unsub();

    window.removeEventListener('resize', this.resizeEventHandler);
  }

  resizeEventHandler() {
    const vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty('--onboarding-vh', `${vh}px`);
  }
}
